import RecruitApiClient from '../../RecruitApiClient';

class Api {
  refineScreening = (id: number, conditions: any[]) => RecruitApiClient.post(`/api/v4/candidate_sourcing/searches/${id}/refine_screening`, { conditions });
  createCandidatePool = (title: string) => RecruitApiClient.post(`/api/v4/candidate_sourcing/candidate_pools`, { title });
  addCandidatesToPools = (candidateGroupIds: number[], poolIds: number[]) =>
    RecruitApiClient.post(`/api/v4/candidate_sourcing/candidate_pools/add_candidates`, { candidate_group_ids: candidateGroupIds, pool_ids: poolIds });
  getCandidatePools = () => RecruitApiClient.get(`/api/v4/candidate_sourcing/candidate_pools`);
  getEmailTemplates = () => RecruitApiClient.get(`/api/v4/searches/email_templates?group_templates=true`);
  sendEmails = (data: any) => RecruitApiClient.post(`/api/v4/searches/bulk_email`, data);
  getEmailTemplateDetails = (id: string) => RecruitApiClient.get(`/api/v4/searches/email_templates/${id}`);
  getScreeningCandidates = (id: number, page: number, limit: number) => RecruitApiClient.get(`/api/v4/candidate_sourcing/searches/${id}/search_candidates`, { page, limit, screening: 1 });
  revealContacts = (searchId: number, groupId: number) => RecruitApiClient.post(`/api/v4/candidate_sourcing/searches/${searchId}/candidate_groups/${groupId}/reveal_contacts`);
  allCandidateGroupIds = (searchId: number) => RecruitApiClient.get(`/api/v4/candidate_sourcing/searches/${searchId}/candidate_groups/all_ids`);
}

export default new Api();
